
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M12 23.501c-6.341 0-11.5-5.159-11.5-11.5S5.659.501 12 .501s11.5 5.159 11.5 11.5-5.159 11.5-11.5 11.5zm0-22c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5z"}}),_c('circle',{attrs:{"cx":"12","cy":"17.5","r":".75"}}),_c('path',{attrs:{"d":"M12 15.5a.5.5 0 01-.5-.5v-.412a2.5 2.5 0 011.5-2.291 2.5 2.5 0 00-1-4.792c-.668 0-1.296.26-1.768.732a2.484 2.484 0 00-.732 1.768.5.5 0 01-1 0c0-.935.364-1.814 1.026-2.475A3.477 3.477 0 0112 6.505c.934 0 1.813.365 2.474 1.026a3.5 3.5 0 01-1.074 5.682 1.5 1.5 0 00-.9 1.375V15a.5.5 0 01-.5.5z"}})])])
          )
        }
      }
    